import { getUserRoleEntryByRoleId } from '../utils/userRoles';
import { PermissionLevelProps, PermissionRolesProps } from '../types/permissions';
import { permissionLevelsCatalog } from '../constants/permissions';
import { RootState, useAppSelector } from '../redux/store';
import { useEffect, useMemo, useState } from 'react';
import { UserRoles } from '../types/user-roles';

export const usePermissions = (): {
  isAllowed: (props: PermissionLevelProps | PermissionRolesProps) => boolean;
  isReadOnlyUser: boolean;
} => {
  const authState = useAppSelector((state: RootState) => state.auth);

  const [userRole, setUserRole] = useState<UserRoles | undefined>(undefined);

  useEffect(() => {
    if (authState.authContext?.securityLevelId) {
      const id = Number(authState.authContext?.securityLevelId);
      const userRole = authState.isOwner ? UserRoles.OWNER : getUserRoleEntryByRoleId(id)?.role;
      setUserRole(userRole);
    } else {
      setUserRole(undefined);
    }
  }, [authState.authContext, authState.isOwner]);

  const isAllowed = useMemo(() => {
    return (props: PermissionLevelProps | PermissionRolesProps) => {
      if (props.allowedRoles) {
        return Array.isArray(props.allowedRoles)
          ? props.allowedRoles.includes(userRole as UserRoles)
          : userRole === props.allowedRoles;
      } else if (props.allowedPermissionLevels) {
        return permissionLevelsCatalog[props.allowedPermissionLevels].includes(
          userRole as UserRoles,
        );
      } else {
        return false;
      }
    };
  }, [userRole]);

  const isReadOnlyUser = useMemo(() => {
    return authState.authContext?.readOnly !== false;
  }, [authState.authContext]);

  return { isAllowed, isReadOnlyUser };
};
